import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMatch, useSearchParams } from "react-router-dom";
import AttendeeAbout from "../../components/attendeeEvent/AttendeeAbout";
import AttendeeBottomBar from "../../components/attendeeEvent/AttendeeBottomBar";
import AttendeeSchedule from "../../components/attendeeEvent/AttendeeSchedule";
import AttendeeSideMenu from "../../components/attendeeEvent/AttendeeSideMenu";
import Attendees from "../../components/people/Attendees";
import { getSingleEvent } from "../../redux/actions/eventActions";
import { AnimatePresence, motion } from "framer-motion";
import ScannedCardLeads from "../../components/people/ScannedCardleads";

function AttendeeSingleEvent() {
  const [searchParams] = useSearchParams();
  const eventsId = useMatch("/attendee/:eventId/*");
  const dispatch = useDispatch();
  const tab = searchParams.get("tab");
  const singleEvent = useSelector((state) => state.eventData);

  useEffect(() => {
    dispatch(
      getSingleEvent({
        eventId: eventsId.params.eventId,
        queries: `?populateOrganizers=true&select=primaryOrganizer schedule`,
      })
    );
    return () => {};
  }, [dispatch, eventsId.params.eventId]);

  const tabComponents = {
    about: <AttendeeAbout singleEvent={singleEvent} />,
    agenda: <AttendeeSchedule singleEvent={singleEvent} />,
    leads: <Attendees />,
    cards: <ScannedCardLeads />,
  };

  return (
    <>
      <AttendeeSideMenu singleEvent={singleEvent} />

      <AnimatePresence mode="wait">
        <motion.div
          key={tab} // important for AnimatePresence
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {tabComponents[tab] || <AttendeeAbout singleEvent={singleEvent} />}
        </motion.div>
      </AnimatePresence>

      <AttendeeBottomBar />
    </>
  );
}

export default AttendeeSingleEvent;
